// extracted by mini-css-extract-plugin
export var wordContainer = "_pd-0";